import Hero from './components/Hero';
import Navigation from './components/Navigation';
import Enemy from './components/Enemy';
import BillyOwner from './components/BillyOwner';
import Team from './components/Team';
import HonorCode from './components/HonorCode';
import SnapSystem from './components/SnapSystem';
import Technology from './components/Technology';
import HowItWorks from './components/HowItWorks';
import WhatYouGet from './components/WhatYouGet';
import PartnerCredibility from './components/PartnerCredibility';
import CalmGuarantee from './components/CalmGuarantee';
import Avatars from './components/Avatars';
import OurWork from './components/OurWork';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import ServiceAreaMap from './components/ServiceAreaMap';
import Footer from './components/Footer';
import MobileCTA from './components/MobileCTA';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      
      {/* Mobile: proper section spacing + bottom padding for sticky bar */}
      <div className="pb-20 lg:pb-0">
        <div className="space-y-14 sm:space-y-16 lg:space-y-20">
          <Enemy />
          <HowItWorks />
          <CalmGuarantee />
          <SnapSystem />
          <WhatYouGet />
          <Avatars />
          <BillyOwner />
          <Team />
          <HonorCode />
          <OurWork />
          <PartnerCredibility />
          <Reviews />
          <Technology />
          <Contact />
          <ServiceAreaMap />
          <FAQ />
        </div>
      </div>
      
      <Footer />
      <MobileCTA />
    </div>
  );
}